import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import { ModalsAppState } from '@redux/states/appState'
import { LuxReactionPicker, LuxReactionCounter } from '@lux/wardrobe-lib'
import './MessageCtaContainer.scss'
import { NEW_ACTIVITY_EXECUTION_NAMESPACE } from '@/app/redux/reducers/activity-execution'

const MessageCtaContainer = (props: any) => {
    const {
        updateTotalReactions,
        onComment,
        reactionTypeList,
        total,
        onMarkAsRead,
        isUnread,
        isMessageReactionLoading,
        totalReply,
    } = props

    const intl = useIntl()

    const componentClass = 'modals-new-activity-execution-message-cta-container'

    const reactionHandler = (type: string) => {
        updateTotalReactions(type)
    }

    return (
        <div className={componentClass}>
            <div className={componentClass}>
                <div className={`${componentClass}__cta-left`}>
                    <div className={`${componentClass}__cta reaction-picker`}>
                        <LuxReactionPicker
                            label="Like"
                            icon="thumb-up"
                            onSelectReaction={reactionHandler}
                            overlayAdditionalProps={{ appendTo: 'self' }}
                        />
                    </div>
                    <div
                        className={`${componentClass}__cta reply text-mini`}
                        onClick={onComment}
                        aria-hidden="true">
                        {intl.formatMessage({
                            id: 'modals.new.activity.execution.messaging.cta.comment',
                            defaultMessage: 'Reply',
                        })}
                    </div>
                    <div className={`${componentClass}__cta text-mini`}>
                        {totalReply > 0 ? `(${totalReply})` : ''}
                    </div>
                </div>
                <div className={`${componentClass}__cta-right`}>
                    {!reactionTypeList.length && isUnread && (
                        <div
                            className={`${componentClass}__cta text-mini`}
                            onClick={onMarkAsRead}
                            aria-hidden="true">
                            {intl.formatMessage({
                                id: 'modals.new.activity.execution.messaging.cta.mark.as.read',
                                defaultMessage: 'Mark as read',
                            })}
                        </div>
                    )}
                    {reactionTypeList.length > 0 && (
                        <LuxReactionCounter
                            reactionTypes={reactionTypeList}
                            count={total}
                            countPosition="left"
                            loading={isMessageReactionLoading}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: ModalsAppState) => ({
    isMessageReactionLoading: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].isMessageReactionLoading,
})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(MessageCtaContainer)
